import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasNotifications, filters }) => {
  const hasActiveFilters = filters?.type !== 'all' || 
                          filters?.priority !== 'all' || 
                          filters?.status !== 'all' || 
                          filters?.search?.length > 0;

  if (hasActiveFilters) {
    return (
      <div className="bg-white rounded-2xl border border-[#E5E7EB] p-8 md:p-12 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-[#F6F7FB] border-2 border-[#E5E7EB] flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} color="#6B7280" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-2">
          No Matching Notifications
        </h3>
        <p className="text-sm md:text-base text-[#6B7280] mb-6 max-w-md mx-auto">
          No notifications match your current filters. Try adjusting your search criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] p-8 md:p-12 text-center">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-gradient-to-br from-[#5B2DFF] to-[#8B5CF6] border-2 border-[#5B2DFF]/20 flex items-center justify-center mx-auto mb-4">
        <Icon name="Bell" size={32} color="#FFFFFF" />
      </div>
      <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-2">
        You're All Caught Up!
      </h3>
      <p className="text-sm md:text-base text-[#6B7280] mb-6 max-w-md mx-auto">
        No notifications yet. We'll notify you when you receive matches, messages, or interview invitations.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="default"
          size="default"
          iconName="Users"
          onClick={() => window.location.href = '/opportunity-feed'}
        >
          Browse Opportunities
        </Button>
        <Button
          variant="outline"
          size="default"
          iconName="MessageSquare"
          onClick={() => window.location.href = '/secure-chat-interface'}
        >
          View Messages
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;